<template>
    <div>
        <Header></Header>
        <div class="container self-container">
            <CommentSlice 
            :setCommentNum="setCommentNum" 
            :publishUserId="publishUserId" 
            :articleId="articleId"
            btnText="发表"
            hits="请聊聊最近找工作的感受吧">
            </CommentSlice>
        </div>
    </div>
</template>
<style>
.comm>h4{display: none;}
</style>
<style scoped>
.self-container{text-align: left;}
</style>
<script>
import Header from "./headernew";
import CommentSlice from "../component-slice/comment_slice.vue";
import "../assets/css/common.css";
export default {
    components: {
        Header,
        CommentSlice,
    },
    data() {
        return {
            commentNum: 0,
            publishUserId: 9,
            articleId: 0
        }
    },
    mounted() {
        //为什么这里需要重新赋值给articleId，那是因为在comment_slice组件那里是通过
        //watch观察这个articleId的变化才会向后端发起请求
        this.articleId=46;
    },
    methods: {
        setCommentNum(commNum) {
            this.commentNum = commNum;
        },
    }
}
</script>
